// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Tooltip, Typography, useMediaQuery } from '@mui/material';

// project imports
import LAYOUT_CONST from 'constant';
import useConfig from 'hooks/useConfig';
import LogoSection from '../../CandidateLayout/LogoSection';
import usePublicBranding from 'hooks/usePublicBranding';
import ProfileSection from './ProfileSection';
import FullScreenSection from './FullScreenSection';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons-react';

const styles = {
    logoWrap: (theme) => ({
        width: 180,
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    }),
    logoDesktop: {
        display: { xs: 'none', md: 'block' },
        flexGrow: 1
    },
    portalLabel: {
        minWidth: 0,
        pl: 1,
        borderLeft: { xs: 'none', md: '1px solid white' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflow: 'hidden'
    },
    portalText: {
        color: 'white',
        fontSize: { xs: '1rem', sm: '1.5rem' },
        lineHeight: 1.2,
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    organisationText: {
        color: 'common.white',
        opacity: 0.85,
        fontSize: { xs: '0.75rem', sm: '0.875rem' },
        lineHeight: 1.3,
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { layout } = useConfig();

    const { tradingName = '' } = usePublicBranding();
    const organisationName = typeof tradingName === 'string' ? tradingName.trim() : '';
    const organisationDescription = organisationName || 'Candidate Portal';
    const displayedOrganisationDescription =
        organisationDescription.length > 50 ? `${organisationDescription.slice(0, 50).trimEnd()}…` : organisationDescription;
    return (
        <>
            {/* logo & toggler button */}
            <Box sx={styles.logoWrap(theme)}>
                <Box component="span" sx={styles.logoDesktop}>
                    <LogoSection />
                </Box>

                {layout === LAYOUT_CONST.VERTICAL_LAYOUT || (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ? (
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            overflow: 'hidden',
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                                color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                            }
                        }}
                        onClick={() => dispatch(openDrawer(!drawerOpen))}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="20px" />
                    </Avatar>
                ) : null}
            </Box>
            {/* header search */}
            <Box sx={styles.portalLabel}>
                <Typography variant="h3" className="main-font-b" sx={styles.portalText}>
                    Guest Evidence Request
                </Typography>
                <Tooltip title={organisationDescription} arrow>
                    <Typography variant="subtitle2" className="main-font" sx={styles.organisationText} aria-label={organisationDescription}>
                        {displayedOrganisationDescription}
                    </Typography>
                </Tooltip>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            {/* full sceen toggler */}
            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <FullScreenSection />
            </Box>
            {/* profile */}
            <ProfileSection />
        </>
    );
};

export default Header;
